
















































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import User from "@/models/user";

@Component
export default class UserResendConfirmationEmail extends Vue {
  user!: User;

  checkEmail = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error("Your email address is required"));
    } else {
      // check if the mail is valid
      const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regExp.test(String(value).toLowerCase())) {
        return callback(new Error("Please enter a valid email address"));
      }

      return callback();
    }
  };

  resendForm: any = {
    email: "",
  };

  rules: any = {
    email: [
      {
        validator: this.checkEmail,
        required: true,
        trigger: ["blur"],
      },
    ],
  };

  loading = false;
  resendCodeEmailed = false;
  @Ref("resendFormRef")
  resendFormRef!: any;

  @Ref("resendInput")
  resendInput!: any;

  mounted() {
    this.resendInput.focus();
  }

  resend() {
    this.resendFormRef.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;

        this.$store
          .dispatch(
            "authentication/sendConfirmationEmail",
            this.resendForm.email
          )
          .then(
            () => {
              this.loading = false;
              this.resendCodeEmailed = true;
              this.resendForm.email = "";
            },
            () => {
              this.loading = false;
              this.resendCodeEmailed = true;
              this.resendForm.email = "";
            }
          );
      }
    });
  }
}
